export default __webpack_public_path__ + "static/media/AIlogx.95a22fe6.png";